export default __webpack_public_path__ + "static/Vol 3 - TA 2A - EcA (with appendices)-97d011d33d171e80aa3d4054fc205542.pdf";